var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("input", {
    attrs: {
      type: "date",
    },
    domProps: {
      value: _vm.formattedDate,
    },
    on: {
      input: _vm.onInput,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }